/** @format */

import { Button, Card } from "react-bootstrap";

//image
import defaultJobCover from "src/assets/images/defaultBanner.jpeg";

const ProfileHeader = ({ selectedJob, loading, handleOpenModal }) => (
  <Card.Body className="profile-page p-0">
    <div className="profile-header profile-info">
      <div className="cover-container bg-success border">
        <img
          loading="lazy"
          src={defaultJobCover}
          alt="profile-bg"
          style={{ objectFit: "cover" }}
          className="rounded img-fluid"
        />
      </div>
      <div className="profile-info py-5 px-md-5 px-3 d-flex align-items-center justify-content-between position-relative border border-inherit">
        <div className="profile-img">
          <img
            loading="lazy"
            src={selectedJob.company.logo.url}
            alt="profile-img"
            className="avatar-130 img-fluid"
          />
        </div>
        <div className="profile-detail">
          <h1 className="fs-3 fw-bold">
            {selectedJob?.title || "No job selected"}
          </h1>
          <h3>{selectedJob?.company.name || "Company not available"}</h3>
          <p>{selectedJob?.salary || "Salary not available"}</p>
        </div>
        <div>
          <div className="social-info">
            <ul className="social-data-block social-user-meta-list d-flex align-items-center justify-content-center list-inline p-0 m-0 gap-1">
              <li className="text-center">
                <h6 className="border border-success p-2 d-inline-block rounded">
                  Full Time
                </h6>
              </li>
              <li className="text-center">
                <span className="material-symbols-outlined">favorite</span>
                <h6>Save</h6>
              </li>
              <li className="text-center">
                <span className="material-symbols-outlined">share</span>
                <h6>Share</h6>
              </li>
            </ul>
          </div>
          <div className="text-center">
            <Button
              className="mt-2 w-100"
              onClick={handleOpenModal}
              disabled={loading}
            >
              {loading ? "Applying..." : "Apply Now"}
            </Button>
          </div>
        </div>
      </div>
      <div>
        <Card.Body>
          {" "}
          <h3>Description</h3>
          <br></br>
          <h6>{selectedJob?.description || "Company not available"}</h6>
        </Card.Body>
      </div>
    </div>
  </Card.Body>
);

export default ProfileHeader;
